import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { FiUser, FiMail, FiPhone, FiMessageSquare, FiCheckCircle } from 'react-icons/fi';
import './../styles/Contact.css';
import { contactForm } from '../services/Service';

const Contact = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.first_name.trim()) {
      newErrors.first_name = 'First name is required.'
    } else if (formData.first_name.length > 255) {
      newErrors.first_name = 'First name should not be greater than 255 characters.';
    };
    if (!formData.last_name.trim()) {
      newErrors.last_name = 'Last name is required.'
    } else if (formData.first_name.length > 255) {
      newErrors.first_name = 'Last name should not be greater than 255 characters.';
    };
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid.';
    }
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone Number is required.'
    } else if (formData.phone.length > 255) {
      newErrors.phone = 'Phone Number should not be greater than 255 characters.';
    };
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required.'
    } else if (formData.message.length > 255) {
      newErrors.message = 'Message should not be greater than 255 characters.';
    };
    return newErrors;
  };
  // const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors({}); // Clear previous form-level errors

    if (Object.keys(newErrors).length === 0) {
      try {
        const responseData = await contactForm(formData);
        if (responseData && responseData.data.message === 'Contact successfully created.') {
          setIsSubmitted(true);
          window.scrollTo(0, 0);
          setFormData({
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            message: ''
          });
        } else {
          setIsSubmitted(false);
          // Display error message from backend if available, otherwise a generic one
          setErrors({ form: responseData?.message || responseData?.error || 'Form submission failed. Please try again later.' });
        }
      } catch (error) {
        setIsSubmitted(false);
        // It's good to log the actual error for debugging
        setErrors({ form: 'An unexpected error occurred. Please try again later.' });
      }
    } else {
      setErrors(newErrors);
    }
  };

  if (isSubmitted) {
    return (
      <div className="contact-us-container">
        <div className="success-message">
          <FiCheckCircle className="w-5 h-5" />
          <h1>Thank You!</h1>
          <p>Your message has been sent successfully. We'll get back to you soon.</p>
          <button onClick={() => setIsSubmitted(false)}>Send Another Message</button>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-us-container">
      <div className="contact-left">
        <h1>Contact Us</h1>
        <p>Have questions or feedback? We'd love to hear from you!</p>

        <div className="contact-info">
          <div className="info-item">
            <FaEnvelope className="info-icon" />
            <span><a href="mailto:contact@webcruxtechnology.com" className="custom-link">contact@webcruxtechnology.com</a></span>
          </div>
          <div className="info-item">
            <FaPhone className="info-icon" style={{ transform: 'scaleX(-1)' }} />
            <span><a href="tel:+918401181455" className="custom-link">+91 8401181455</a></span>
          </div>
          <div className="info-item">
            <FaMapMarkerAlt className="info-icon" />
            <span>Vandemataram, Ahmedabad, 382481</span>
          </div>
        </div>
      </div>

      <div className="contact-right">
        <form onSubmit={handleSubmit} className="contact-form" noValidate>
          <div className="form-row">
            <div className={`form-group required ${errors.first_name ? 'has-error' : ''}`}>
              <label htmlFor="first_name">First Name</label>
              <div className="input-with-icon">
                <FiUser className="input-icon" />
                <input
                  type="text"
                  id="first_name"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  placeholder="Enter First Name"
                  className={errors.first_name ? 'error' : ''}
                  autoComplete="off"
                  onBlur={() => {
                    if (!formData.first_name) {
                      setErrors((prev) => ({ ...prev, first_name: 'first name is required.' }));
                    } else {
                      setErrors((prev) => {
                        const { first_name, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                />
              </div>
              {errors.first_name && <span className="error-message">{errors.first_name}</span>}
            </div>

            <div className="form-group required">
              <label htmlFor="last_name">Last Name</label>
              <div className="input-with-icon">
                <FiUser className="input-icon" />
                <input
                  type="text"
                  id="last_name"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Enter Last Name"
                  className={errors.last_name ? 'error' : ''}
                  autoComplete="off"
                  onBlur={() => {
                    if (!formData.last_name) {
                      setErrors((prev) => ({ ...prev, last_name: 'last name is required.' }));
                    } else {
                      setErrors((prev) => {
                        const { last_name, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                />
              </div>
              {errors.last_name && <span className="error-message">{errors.last_name}</span>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group required">
              <label htmlFor="email">Email</label>
              <div className="input-with-icon">
                <FiMail className="input-icon" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter Email"
                  className={errors.email ? 'error' : ''}
                  autoComplete="off"
                  onBlur={() => {
                    if (!formData.email) {
                      setErrors((prev) => ({ ...prev, email: 'email is required.' }));
                    } else {
                      setErrors((prev) => {
                        const { email, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                />
              </div>
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            <div className="form-group required">
              <label htmlFor="phone">Phone Number</label>
              <div className="input-with-icon">
                <FiPhone className="input-icon" />
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter Phone number"
                  className={errors.phone ? 'error' : ''}
                  autoComplete="off"
                  onBlur={() => {
                    if (!formData.phone) {
                      setErrors((prev) => ({ ...prev, phone: 'phone is required.' }));
                    } else {
                      setErrors((prev) => {
                        const { phone, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                />
              </div>
              {errors.phone && <span className="error-message">{errors.phone}</span>}
            </div>
          </div>

          <div className="form-group required">
            <label htmlFor="message">Message</label>
            <div className="input-with-icon">
              <FiMessageSquare className="input-icon" />
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter message"
                className={errors.message ? 'error' : ''}
                onBlur={() => {
                  if (!formData.message) {
                    setErrors((prev) => ({ ...prev, message: 'message is required.' }));
                  } else {
                    setErrors((prev) => {
                      const { message, ...rest } = prev;
                      return rest;
                    });
                  }
                }}
              />
            </div>
            {errors.message && <span className="error-message">{errors.message}</span>}
          </div>
          <div className="center-btn">
            <button type="submit" className="submit-btn" style={{ marginTop: '0.5rem' }}>Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;